export const clusterDetailTable = {
    returnListLink: 'Return to the cluster list',
    title: 'Cluster ID',
    selected: 'selected',
    tabTitleOfIpc: 'IPC (International Patent Classification)',
    tabTitleOfCompany: 'Owner Companies of Patent Applications',
    tabTitleOfPatentTable: 'List of Patent Applications',
    tabTitleOfPatentChart: 'Time Series of Patent Applications'
}
